export const Addresses = {
    VeDelegate: '0xfc32a9895C78CE00A1047d602Bd81Ea8134CC32b',
    VeDelegateVotes: '0xeb71148c9B3cd57e228c2152d79f6e78F5F1ef9a',
    VePassport: '0x35a267671d8EDD607B2056A9a13E7ba7CF53c8b3',
    B3TR: '0x5ef79995FE8a89e0812330E4378eB2660ceDe699',
    VOT3: '0x76Ca782B59C74d088C7D2Cce2f211BC00836c602',
    Rewarder: '0x838A33AF756a6366f93e201423E1425f67eC0Fa7',
    AllocationVoting: '0x89A00Bb0947a30FF95BEeF77a66AEdE3842Fe5B7',
    Emission: '0xDf94739bd169C84fe6478D8420Bb807F1f47b135',
    Trigger: '0x642a263BeE274109A2513f219E9DC975D64E4ebE'
}

export const Constants = {
    MINIMUM_STAKE_AMOUNT: 50, // Minimum B3TR required to stake
};

export const GRAPH_URL = "https://graph.vet/subgraphs/name/vebetter/dao"